let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gLb7k")).then(() => parcelRequire('5Yzmr'));